import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import { AppModule } from '@/store/modules/app'
import i18n from '@/lang' // Internationalization
import settings from './settings'
import { getName } from '@/utils/cookies'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect', '/jump', '/product/accountLog']

const getPageTitle = (key: string) => {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${settings.title}`
  }
  return `${settings.title}`
}

router.beforeEach(async (to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start()

  // 用户是否已登录
  if (UserModule.token) {
    if (to.path === '/login') {
      // 已登录时，访问登录页则跳到首页
      next({ path: '/' })
      NProgress.done()
    } else {
      // 用户权限是否存在
      if (
        PermissionModule.permission.length === 0 &&
        to.path !== '/enterpriseApp' &&
        to.path !== '/jump'
      ) {
        try {
          // 获取用户对应的菜单权限列表
          await PermissionModule.GetMenu().then(() => {
            const menu = PermissionModule.menu
            // 根据权限菜单生成动态路由
            PermissionModule.GenerateRoutes(menu)
            router.addRoutes(PermissionModule.dynamicRoutes)
          })
          if (AppModule.enterprise.available_currency.length === 0) {
            await AppModule.GetEnterprise()
            await AppModule.GetConstant()
          }
          await next({ ...to, replace: true })
        } catch (err) {
          // 清除token，重定向到登录页
          UserModule.ResetToken()
          AppModule.ResetEnterprise()
          Message.error('Has Error')
          await next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      } else {
        next()
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()

  // set page title
  // to.meta && (document.title = getPageTitle(to.meta.title))
})
